import React from "react";
import type { ReactNode } from "react";

type U2000PanelProps = {
  title?: string | ReactNode;
  titleAlign?: "left" | "center";
  children?: ReactNode;
  className?: string;
  variant?: "default" | "elevated" | "outlined";
};

const U2000Panel: React.FC<U2000PanelProps> = ({ title, titleAlign = "left", children, className = "", variant = "default" }) => {
  // Styles modernes avec le système de design établi
  const getVariantClasses = () => {
    switch (variant) {
      case "elevated":
        return "bg-white border border-gray-200 shadow-lg";
      case "outlined":
        return "bg-white border-2 border-gray-300 shadow-xs";
      default:
        return "bg-white border border-gray-200 shadow-md";
    }
  };

  return (
    <div className={`relative rounded-lg p-4 pt-6 transition-shadow duration-200 ${getVariantClasses()} ${className}`}>
      {title && (
        <div
          className={`absolute -top-3 bg-white px-3 py-1 text-sm font-semibold text-gray-700 
                     border border-gray-200 rounded-md shadow-xs select-none
                     ${titleAlign === "center" ? "left-1/2 -translate-x-1/2 text-center" : "left-4 text-left"}`}
          style={{ zIndex: 1 }}
        >
          {title}
        </div>
      )}
      <div className="w-full animate-fade-in">{children}</div>
    </div>
  );
};

export default U2000Panel;
